import * as React from "react";
import {FileDropper} from "../../../utils/interaction/draganddrop/FileDropper";
import {WarningWindow} from "../../modules/abstract/popups/WarningWindow";

interface IFileDropperWrapperProps {
	readonly accept: string;
	readonly children: React.ReactElement;
	readonly onFileInputChange: (files: FileList) => void;
}

export class FileDropperWrapper extends React.Component<IFileDropperWrapperProps> {
	private _dropper: FileDropper;
	private readonly _containerRef = React.createRef<HTMLDivElement>();

	private onDragOver = (event: DragEvent) => {
		// TODO: what's the purpose of this?

		return true;
	};

	private async onFileChange(files: FileList) {
		if (this._dropper.checkType(files)) {
			this.props.onFileInputChange(files);
		} else {
			await WarningWindow.open(`Wrong filetype! Only the following types are accepted: ${this.props.accept}`);
		}

		// To replace "value" with an empty string. So if the user deletes the previously selected item from a list, and then selects the same file again, onFileChange is triggered
		this.forceUpdate();
	}

	private onDrop = (event: DragEvent) => {
		this.onFileChange(event.dataTransfer.files);
	};

	public override componentDidMount() {
		this._dropper = new FileDropper({
			targetElement: this._containerRef.current?.children[0],
			onDragOver: this.onDragOver,
			onDrop: this.onDrop,
			accept: this.props.accept,
		});
	}

	public override componentWillUnmount() {
		if (this._dropper) {
			this._dropper.disable();
		}
	}

	public override render() {
		return (
			<div
				ref={this._containerRef}
				style={{display: "contents"}}
			>
				{this.props.children}
			</div>
		);
	}
}
